import React, { useContext} from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import { Wrapper, Grid, Content ,Item} from "./styles";


export const Skills = () => {
  const { theme } = useContext(ThemeContext);
  var list =
  [
  {"name":"C++" , "logo":"https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/1200px-ISO_C%2B%2B_Logo.svg.png"},
  {"name":"Node.js" , "logo":"https://www.logolynx.com/images/logolynx/c5/c509c38cb89bcf556b2051222663f398.png"},
  {"name":"React.js" , "logo":"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png"},
  {"name":"MongoDB" , "logo":"https://img.icons8.com/color/452/mongodb.png"},
  {"name":"MySQL" , "logo":"https://pngimg.com/uploads/mysql/mysql_PNG23.png"},
  {"name":"Linux" , "logo":"https://pngimg.com/uploads/linux/linux_PNG1.png"},
  {"name":"Express.js" , "logo":"https://cdn.iconscout.com/icon/free/png-512/node-js-1174925.png"},
  {"name":"HTML" , "logo":"https://www.w3.org/html/logo/downloads/HTML5_Logo_512.png"},
  {"name":"CSS" , "logo":"https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_1280.png"},
  {"name":"Git" , "logo":"https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png"}
  ]
  return (
    <Wrapper as={Container} id="skills">
    <h2>Skills</h2><br></br>
      <Grid>
      {list.map((item) =>
      <Item>
      <Card theme={theme} style={{textAlign:"center"}} data-aos="flip-up">
              <Content>
                <h4>{item.name}</h4>
                <img src={item.logo} style={{width:"30%"}}></img>
              </Content>
              <br></br>
            </Card>
            </Item>
        )}
            
      </Grid>
    </Wrapper>
  );
};
